export function getUsageLimitLabel(limit) {
  return typeof limit === 'number' && limit > 0 ? limit : 'Unlimited';
}
